import { JSX } from 'react';
import classNames from 'classnames';
import { Loader } from '@bg-components/Loader';
import classes from './LoadingPage.module.scss';

interface IProps {
    className?: string;
}

export const LoadingPage = (props: IProps): JSX.Element => (
    <div className={classNames(classes.loader, props.className)}>
        <Loader />
    </div>
);
